module.exports = new __parcel__URL__("Meeting notes.14684091.svg").toString();